import React, { useState, useEffect, useCallback, memo, useRef } from 'react';
import { getFirestore, collection, query, getDocs, doc, getDoc, setDoc, Timestamp } from "@firebase/firestore";
import { app } from '../../firebase.js';
import { getAuth } from "firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import swal from 'sweetalert';
import Table from 'react-bootstrap/Table'; 

function DebtsComp() {
    const db = getFirestore(app);
    const auth = getAuth();
    const [modalShowUp, setModalShowUp] = useState(false);
    const [branchesList, setBranchesList] = useState([]);
    const [requiLists, setRequiLists] = useState([]);
    const [billsList, setBillsList] = useState([]);
    const [paymentModalShow, setPaymentModalShow] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState('');
    const [loading, setLoading] = useState(true);
    const [branchMapping, setBranchMapping] = useState({});


    useEffect(() => {
        const fetchBranches = async () => {
            const q = query(collection(db, 'Branches'));
            const querySnapshot = await getDocs(q);
            const branches = [];
            const mapping = {};
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                branches.push({ id: doc.id, ...data });
                mapping[doc.id] = data.branchName;
            });
            setBranchesList(branches);
            setBranchMapping(mapping);
        };
        fetchBranches();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const q = query(collection(db, 'Loans'));
            const querySnapshot = await getDocs(q);
            const vendors = [];
            querySnapshot.forEach((doc) => {
                vendors.push({ id: doc.id, ...doc.data() });
            });
            setRequiLists(vendors); 
        };
        fetchData();
    }, []);


    function MyUpdateModal(props) {
        return (
            <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add a Debt / Loan Record
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Select a Campus</Form.Label>
                        <Form.Select aria-label="Default select example" ref={selectedCampus} >
                            {branchesList.map((vendor) => (
                                <option key={vendor.id} value={vendor.docID}>{vendor.branchName}</option>
                            ))}
                             <option value="General">General</option>
                        </Form.Select> 
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Lender / Person we owe</Form.Label>
                        <Form.Control type="text"  ref={personWeOwe}/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Loan/Debt Description</Form.Label>
                        <Form.Control type="text" ref={loanDesc}  />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Principal Amount</Form.Label>
                        <Form.Control type="number" ref={principalAmount} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Date borrowed / Date Active</Form.Label>
                        <Form.Control type="datetime-local" ref={dateBorrowed} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Due Date</Form.Label>
                        <Form.Control type="datetime-local" ref={dueDate} />
                    </Form.Group> 

                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
                    <Button variant="primary" id='submitBtn' onClick={addLoanRecord} >Submit</Button>
                    <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        <span> Submitting...</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    const selectedCampus = useRef();
    const personWeOwe = useRef();
    const loanDesc = useRef(); 
    const principalAmount = useRef();
    const dateBorrowed = useRef();
    const dueDate = useRef();

    function addLoanRecord(){

        const theselectedCampus = selectedCampus.current.value;
        const thepersonWeOwe = personWeOwe.current.value;
        const theloanDesc = loanDesc.current.value;
        const theprincipalAmount = principalAmount.current.value;
        const thedateBorrowed = dateBorrowed.current.value;
        const thedueDate = dueDate.current.value;

        document.getElementById("submitBtn").style.display = "none";
        document.getElementById("spinnerbtn").style.display = "block";


        const newDataRef = doc(collection(db, "Loans"));
        setDoc(newDataRef, {
            selectedCampus: theselectedCampus,
            personWeOwe: thepersonWeOwe,
            timeStamp: Timestamp.now(),
            loanDesc: theloanDesc,
            principalAmount: theprincipalAmount,
            dueDate: new Date(thedueDate),
            dateBorrowed: new Date(thedateBorrowed),
            docID: newDataRef.id,
            status: "On Service" 
        }).then(() => {
            swal("Success!", "Loan record added successfully", "success");
            window.location.reload();
        });
    }


    function viewPaymentDetails(docID){

    }

    function viewComments(docID){

    }

  return (
    <div className='teamsComponent'>
        <div className='teamsTopBar'>
            <h5 className='tHide1'>Debts and Loans</h5>
            <h5 className='tHide2'>Debts and Loans</h5>
            <button className='startOnlSessBtn' onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faPlus} className="liveSessionIcon" /> Add a Debt Record
            </button>
            <button className='startOnlSessBtn2' onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faPlus} className="liveSessionIcon" /> Add a Debt Record
            </button>
        </div>
        <br />


        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Campus</th>
                    <th>Lender / Person we owe</th>
                    <th>Loan/Debt Description</th>
                    <th>Principal Amount</th>
                    <th>Date borrowed / Date Active</th>
                    <th>Due Date</th>
                    <th>Status</th>
                    <th>Payment History</th>
                </tr>
            </thead>
            <tbody>
                {requiLists.map((bill) => ( 
                    <tr key={bill.id}> 
                        <td>{branchMapping[bill.selectedCampus]}</td> 
                        <td>{bill.personWeOwe}</td>  
                        <td>{bill.loanDesc}</td>
                        <td>KES. {parseFloat(bill.principalAmount).toLocaleString()}</td>
                        <td>{new Date(bill.dateBorrowed.seconds * 1000).toLocaleDateString()}</td>  
                        <td>{new Date(bill.dueDate.seconds * 1000).toLocaleDateString()}</td> 
                        <td>{bill.status}</td> 
                        <td>
                            <button 
                                className='btn btn-sm btn-primary' 
                                onClick={() => viewComments(bill.docID)}> 
                                View
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
    </div>
  )
}

export default DebtsComp